"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstateReferralRejectionReason_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EstateReferralRejectionReason_Factory = /** @class */ (function () {
    function EstateReferralRejectionReason_Factory() {
    }
    EstateReferralRejectionReason_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedByUserId: model.CreatedByUserId,
            Description: model.Description,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReplacedById: model.ReplacedById,
        };
        return result;
    };
    EstateReferralRejectionReason_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedByUserId: model.CreatedByUserId,
            Description: model.Description,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReplacedById: model.ReplacedById,
        };
        return result;
    };
    return EstateReferralRejectionReason_Factory;
}());
exports.EstateReferralRejectionReason_Factory = EstateReferralRejectionReason_Factory;
